




















import {Component, Vue} from "vue-property-decorator";
import UserLayout from "./layout/page/UserLayout.vue";
import GuestLayout from "./layout/page/GuestLayout.vue";
@Component({
    components: {UserLayout, GuestLayout}
})
export default class App extends Vue {
    mounted() {
        //this.$vuetify.theme.white = true;
        this.$store.dispatch("authInit");
    }
};
